/* src/app/components/preorder-type-chip/preorder-type-chip.component.scss */
.preorder-type-chip {
  height: 16px;
  padding-inline: 10px;
  background: var(--ion-color-primary);
  border: 1px solid var(--preorder-type-chip-border-color);
  border-radius: 28px;
  font-size: 10px;
  line-height: 1px;
  letter-spacing: 0em;
  text-align: center;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
}
/*# sourceMappingURL=preorder-type-chip.component.css.map */
